import React from 'react'
import AB from '../AB.png'
import '../App.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom"

const NavBar = () => {
    return (
<nav className="navbar navbar-expand-lg navbar-light bg-dark">
  <div className="container">

    <Link className="navbar-brand" to="/">
      <img src={AB} alt="logo..." className="logo" />
    </Link>

    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <FontAwesomeIcon icon={faBars} style={{ color: '#fff' }} />
    </button>

    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0">

        <li className="nav-item">
          <Link className="nav-link active" to="/">Accueil</Link>
        </li>

        <li className="nav-item">
          <Link className="nav-link active" to="/aboutme">A propos de moi</Link>
        </li>

        <li className="nav-item">
          <Link className="nav-link active" to="/competences">Mes compétences</Link>
        </li>

        <li className="nav-item">
          <Link className="nav-link active" to="/realisations">Mes réalisations web</Link>
        </li>

        <li className="nav-item">
          <Link className="nav-link active" to="/contactme">Contactez moi</Link>
        </li>

      </ul>
    </div>

  </div>
</nav>
    )
}

export default NavBar
